<template>
  <transition name="modal">
    <div class="modal" tabindex="-1" role="dialog" style="display:block;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header">
              <h5 class="modal-title">Título do modal</h5>
            </slot>

            <button type="button" class="close" @click="close" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <slot name="body">
              <p>Texto do corpo do modal, é aqui.</p>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-outline-primary" @click="confirm">Salvar</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalComponent',
  props: ['show', 'size'],

  created() {},

  watch: {
    show: function() {
      console.log('alterou o show');
    }
  },

  methods: {
    confirm() {
      this.$emit('confirm');
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/Modal.vue